// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
html {
  padding-top: 10.4rem;
}
.pml-navbar .header-separator {
  display: inline-block;
  height: 3.2rem;
  margin: 0 1.6rem;
  vertical-align: middle;
  width: 0.24rem;
  background-color: #0059a4;
}
.pml-navbar .coode-logo-white {
  padding: 1.6rem;
  text-align: center;
}
.pml-navbar .coode-logo-white img {
  height: 4rem;
}
.pml-navbar .adam-header-user__details.adam-header-bar {
  padding: 0;
}
.pml-navbar--dev {
  --header-bar-bg: #b3254c;
}
.pml-navbar--dev .header-separator,
.pml-navbar--dev .adam-header__separator {
  background-color: rgb(157.8680555556, 32.6319444444, 67.0277777778);
}
.pml-navbar--dev .adam-header-notifications__icon:hover,
.pml-navbar--dev .adam-header-user__icon:hover,
.pml-navbar--dev .adam-header-notifications__icon--focused,
.pml-navbar--dev .adam-header-user__icon--focused {
  background-color: rgb(157.8680555556, 32.6319444444, 67.0277777778);
  --stroke: white;
}
.pml-navbar--dev .adam-header__logo.adam-header-bar:hover {
  --fill: rgb(157.8680555556, 32.6319444444, 67.0277777778);
}
.pml-navbar--dev ::selection {
  background: rgb(157.8680555556, 32.6319444444, 67.0277777778);
}
.pml-navbar--uat {
  --header-bar-bg: #8a3898;
}
.pml-navbar--uat .header-separator,
.pml-navbar--uat .adam-header__separator {
  background-color: rgb(121.0817307692, 49.1346153846, 133.3653846154);
}
.pml-navbar--uat .adam-header-notifications__icon:hover,
.pml-navbar--uat .adam-header-user__icon:hover,
.pml-navbar--uat .adam-header-notifications__icon--focused,
.pml-navbar--uat .adam-header-user__icon--focused {
  background-color: rgb(121.0817307692, 49.1346153846, 133.3653846154);
  --stroke: white;
}
.pml-navbar--uat .adam-header__logo.adam-header-bar:hover {
  --fill: rgb(121.0817307692, 49.1346153846, 133.3653846154);
}
.pml-navbar--uat ::selection {
  background: rgb(121.0817307692, 49.1346153846, 133.3653846154);
}
.notification-header {
  margin: 0.8rem 0;
}
.notification-header__context-menu__item {
  width: 44.8rem;
  display: flex;
  flex-direction: row-reverse;
}
.notification-header__context-menu__item--icon {
  width: fit-content;
  padding-right: 0;
}
::v-deep .adam-header-notifications__notification__description {
  white-space: pre-line;
}
::v-deep .adam-header-notifications__notification__description::first-line {
  font-weight: bold;
}
div#app-main ul.pui-context-menu__content {
  z-index: 999999;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
